const API_BASE_URL = process.env.REACT_APP_BACKEND_API_BASE_URL || 'http://localhost:6000';

export const API_ENDPOINTS = {
  // Crypto option chain endpoints
  CRYPTO_OPTION_CHAIN: `${API_BASE_URL}/crypto/option_chain/`,
  CRYPTO_EXPIRIES: (symbol) => `${API_BASE_URL}/crypto/option_chain/expiries?symbol=${symbol}`,
  CRYPTO_SYMBOLS: `${API_BASE_URL}/crypto/option_chain/symbols`,
  CRYPTO_SUMMARY: (symbol, expiry) => `${API_BASE_URL}/crypto/option_chain/summary?symbol=${symbol}&expiry=${expiry}`,

  // Vol Arb endpoints (parameterized for different pairs)
  CRYPTO_SPOT_PRICES: (crypto, etf) => `${API_BASE_URL}/crypto/option_chain/spot_prices?crypto=${crypto}&etf=${etf}`,
  CRYPTO_MATCHED_EXPIRIES: (crypto, etf) => `${API_BASE_URL}/crypto/option_chain/matched_expiries?crypto=${crypto}&etf=${etf}`,
};

// Available trading pairs for vol arb
export const VOL_ARB_PAIRS = [
  { id: 'eth-etha', crypto: 'ETH', etf: 'ETHA', label: 'ETH / ETHA' },
  { id: 'btc-ibit', crypto: 'BTC', etf: 'IBIT', label: 'BTC / IBIT' },
];

export default API_BASE_URL;
